import { render } from "./ExtractosBancariosCrearActualizarComponent.vue?vue&type=template&id=e6f2468c"
import script from "./ExtractosBancariosCrearActualizarComponent.vue?vue&type=script&lang=js"
export * from "./ExtractosBancariosCrearActualizarComponent.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/tesoreria_tolima/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__